import { render } from "./allItems.vue?vue&type=template&id=d640c56c&scoped=true"
import script from "./allItems.vue?vue&type=script&lang=js"
export * from "./allItems.vue?vue&type=script&lang=js"

import "./allItems.vue?vue&type=style&index=0&id=d640c56c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d640c56c"]])

export default __exports__